import * as React from 'react';

import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { LongButton } from './LongButton';
import { CenteredText } from './CenteredText';

interface ArchitectureItemProps {
    label: string;
    imgClass: string;
    onClick: (event?: React.MouseEvent) => void;
    enabled: boolean;
    active: boolean;
}

export class ArchitectureItem extends React.PureComponent<ArchitectureItemProps> {
    public render(): JSX.Element {
        if (AppConfigurationStore.getState().inApp) {
            return (
                <LongButton
                    active={this.props.active}
                    className="article-button short-border"
                    disabled={!this.props.enabled}
                    onClick={this.props.onClick}
                >
                    <CenteredText className="" maxHeight="100%" horizontalAlign="left" verticalAlign="middle">
                        <div className="long-button-text">
                            {this.props.label}
                        </div>
                    </CenteredText>
                    <div className={'button-image ' + this.props.imgClass}/>
                </LongButton>
            );
        }
        return (
            <div
                className={
                    'catalog-item-container catalog-tile' +
                    ((!this.props.enabled) ? ' catalog-item-container-disabled' : '') +
                    ((this.props.active ? ' catalog-item-container-active' : ''))
                }
                onClick={this.props.onClick}
            >
                <div className="catalog-item itemtype-architecture">
                    <div className={'catalog-item-image ' + this.props.imgClass} />
                </div>
                <div className="catalog-item-label">
                    <div className="catalog-item-name">{this.props.label}</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ArchitectureItem.tsx